// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ScreenSharing_wrapper__1rXRq","app-bar":"ScreenSharing_app-bar__31jPX","video":"ScreenSharing_video__1nxLZ","leave-button":"ScreenSharing_leave-button__3rFb-"};